import { useQuery } from '@tanstack/react-query'
import { AdminService } from '@app/services/adminService'

export const useFetchAdminEmailDomains = () => {
  return useQuery<string[]>({
    queryKey: ['admin-email-domains'],
    queryFn: AdminService.getEmailDomains,
  })
}
